"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHotelTotalSellValue = void 0;
const __1 = require("..");
const hotel_1 = require("../hotel");
const calculateHotelTotalSellValue = (hotel_line) => {
    let val = 0;
    const hotel_config = hotel_line;
    const { adjustments, rooms } = hotel_config;
    // Adjustments
    const custom_rate = rooms?.custom || false;
    // Adjustments.  If it's a custom rate, we don't apply the margin discount
    const margin_discount_percentage = custom_rate
        ? 0
        : adjustments?.margin_discount_percentage || 0;
    val = hotel_config.rooms.rooms.reduce((acc, room) => {
        const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(hotel_config.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, room.applied_discount);
        // i may need to do some checking on the applied discount at this point incase any of the options have passed etc. (e.g. early bird discounts)
        const price_summary = (0, __1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
        // this will always return the total price with the discount applied
        return acc + price_summary.total_sell_price_discounted;
    }, 0);
    return val;
};
exports.calculateHotelTotalSellValue = calculateHotelTotalSellValue;
